import React from "react";
import { useTranslation } from "react-i18next";
import OutGoingRequestCard from "../../../../components/requests/OutGoingRequestCard";
import RequestsModel from "../../../../api/models/RequestsModel";
type ReceivedTabProps = {
  requests: RequestsModel[];
};
export const ReceivedTab = (props: ReceivedTabProps) => {
  const { requests } = props;
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  return (
    <div className="flex flex-col w-full gap-6 px-8 py-6 bg-white">
      <div className="flex flex-col">
        <div className="flex flex-col gap-3">
          {requests.length > 0 &&
            requests.map((request, index) => (
              <OutGoingRequestCard request={request} key={index} />
            ))}
        </div>
      </div>
    </div>
  );
};
